import React from 'react';
import PropTypes from 'prop-types';

const MatcherIcon = ({ className, small }) => {
  const dimensions = small ? 40 : 80;
  const heartColor = small ? '#FFFFFF' : '#32B496';
  const innerColor = small ? '#32B496' : '#FFFFFF';
  return (
    <svg
      width={dimensions}
      height={dimensions}
      viewBox="0 0 89 80"
      version="1.1"
      className={className}
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="01_pop_up_inter" transform="translate(-116.000000, -100.000000)">
          <g id="homematcher" transform="translate(20.000000, 100.000000)">
            <g id="Group" transform="translate(96.000000, 0.000000)">
              <path
                d="M44.1533025,80 L42.9582447,79.2205661 C41.4303017,78.2239065 5.55056661,54.6236643 1.24361986,34.9766561 C0.41845625,32.3349808 2.84217094e-14,29.5958274 2.84217094e-14,26.8340138 C2.84217094e-14,17.0889414 5.11585773,8.09146139 13.3512412,3.35273779 C17.1964566,1.1582114 21.5241598,0 25.8730109,0 C32.7688252,0 39.2998366,2.8172921 44.1478197,7.80859917 C48.9711301,2.81690141 55.4890219,0 62.3877734,0 C66.7626679,0 71.0968329,1.15879744 74.921292,3.35097966 C83.1609834,8.10962865 88.2758621,17.1063273 88.2758621,26.8340138 C88.2758621,29.5882089 87.8560351,32.3273622 87.0283259,34.9772421 C84.6964789,45.5961474 73.1544714,57.3700345 62.7988459,66.105485 C53.9953432,73.531648 46.0492394,78.7619313 45.3479687,79.2199801 L44.1533025,80 Z"
                id="like"
                fill={heartColor}
              />
              <polygon
                id="Path"
                fill={innerColor}
                points="49.0019928 49 30.9375 49 30.9375 31.6468595 44.9375 21 58.9375 31.6468595 58.9375 49"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

MatcherIcon.propTypes = {
  className: PropTypes.string,
  small: PropTypes.bool
};

MatcherIcon.defaultProps = {
  className: '',
  small: false
};

export default MatcherIcon;
